import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { SupportTicketSource } from '@nx-c4g/c4g-models';
import {
  SupportTicketDialogComponent,
  SupportTicketDialogData,
} from './support-ticket-dialog.component';

export function openSupportTicketDialog(
  dialog: MatDialog,
  source: SupportTicketSource
): MatDialogRef<SupportTicketDialogComponent, boolean> {
  return dialog.open(SupportTicketDialogComponent, {
    width: '560px',
    maxWidth: '95vw',
    data: { source } as SupportTicketDialogData,
  });
}
